export type Result<T, E = Error> =
  | { ok: true; value: T }
  | { ok: false; error: E };

export class Res {
  static Ok<T, E = Error>(value: T): Result<T, E> {
    return { ok: true, value: value };
  }
  static Fail<T, E = Error>(error: E): Result<T, E> {
    return { ok: false, error };
  }

  static Error<T>(message: string): Result<T, Error> {
    return { ok: false, error: new Error(message) };
  }

  static NoFound<T>(
    elemId: string,
    parameter?: string,
    providerId?: string
  ): Result<T, string> {
    return {
      ok: false,
      error: 'asfdf', // new Error(Message.NotFound(elemId, parameter, providerId)),
    };
  }

  static KeyNoFound<T>(key: string, providerId?: string): Result<T, Error> {
    return {
      ok: false,
      error: new Error(Message.KeyNotFound(key, providerId)),
    };
  }

  static KeyAlreadyExists<T>(
    elemId: string,
    elem?: T,
    providerId?: string
  ): Result<T, Error> {
    return {
      ok: false,
      error: new Error(Message.KeyAlreadyExists(elemId, elem, providerId)),
    };
  }
  static InvalidParameter<T>(
    param: string,
    value?: T,
    providerId?: string
  ): Result<T, Error> {
    return {
      ok: false,
      error: new Error(Message.InvalidParameter(param, value, providerId)),
    };
  }
}

export class Message {
  static NotFound(
    elemId: string,
    parameterName: string = 'id',
    provider: string = 'UNSET_PROVIDER'
  ): string {
    return `Element with '${parameterName}': ${elemId} was not found in provider '${provider}'`;
  }

  static KeyAlreadyExists(
    elemId: string,
    elem: any,
    provider: string = 'UNSET_PROVIDER'
  ): string {
    return `Key ${elemId} for elem ${elem} already exists in provider '${provider}'`;
  }

  static KeyNotFound(
    elemId: string,
    provider: string = 'UNSET_PROVIDER'
  ): string {
    return `Key ${elemId} was not found in provider:'${provider}'`;
  }

  static InvalidParameter(
    param: string,
    value: any,
    provider: string = 'UNSET_PROVIDER'
  ): string {
    return `Invalid parameter. Parameter: name:'${param}' value:'${value}' provider:'${provider}'`;
  }
}
